import { useMemo } from 'react';
import { Stack } from '@chakra-ui/react';

import MeetingRow from '@components/agenda/meeting-row.component';
import { meetingsGroupComparator } from '@util/helpers';

/**
 * @typedef {Object} YourMeetingsProps
 * @property {any} meetingAttendeeMap
 * @property {any} populatedOrganizations
 * @property {Meeting[]} meetings
 *
 * @param {YourMeetingsProps} props
 */
export default function YourMeetings({ meetings, onMeetingActionClick, onCardActionClick }) {
  /** @type {Map<Meeting["start_at"], Meeting[]>} */
  const meetingsByStartTime = new Map();

  meetings?.forEach((meeting) => {
    const startAt = meeting.start_at;
    if (!meetingsByStartTime.has(startAt)) meetingsByStartTime.set(startAt, []);

    const existingStartAtGroup = meetingsByStartTime.get(startAt);
    existingStartAtGroup.push(meeting);
  });

  const meetingGroups = useMemo(() => {
    const mgs = Array.from(meetingsByStartTime.values());
    return mgs.map((meetingsGroup) => meetingsGroup.sort(meetingsGroupComparator));
  }, [meetingsByStartTime]);

  return (
    <Stack
      gap={0}
      border='reskin'
      borderRadius='md'
      overflow='clip'
      bgColor='surface.containerLow'
      data-testid='your-meetings-stack'
    >
      {meetingGroups.map((meetingsGroup, index) => {
        const sortedMeetingItemGroup = meetingsGroup.map((meeting, groupIndex) => {
          let omitBorderTop = false;
          if (index === 0) {
            omitBorderTop = true;
          }

          if (meetingsGroup.length > 1 && groupIndex) {
            omitBorderTop = true;
          }

          return (
            <MeetingRow
              key={meeting?.id}
              meeting={meeting}
              omitBorderTop={omitBorderTop}
              onMeetingActionClick={onMeetingActionClick}
              onCardActionClick={onCardActionClick}
            />
          );
        });

        return sortedMeetingItemGroup;
      })}
    </Stack>
  );
}
